import React from 'react';
import { Grid, Divider } from '@mui/material';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { graphql } from 'gatsby';
import downloadFile from '../assets/NationalSPA.pdf';
import {
  FAQ, Hero, Footer, PrimaryBtn,
} from '../components';

import BlueTheme from '../themes/blue-theme';
import Layout from '../layouts/layout';
import Background from '../assets/hero-elements.svg';

export default function LandingPage() {
  const { t } = useTranslation();

  return (
    <>
      <Layout>
        <Grid
          container
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundImage: `url(${Background})`,
            backgroundPosition: '100px 0',
          }}
        >
          <Hero />
          <Grid item>
            <Divider
              variant="middle"
              sx={{
                backgroundColor: BlueTheme.palette.primary.main,
                marginTop: '6rem',
                height: '3px',
              }}
            />
            <FAQ />
          </Grid>
          <Grid
            item
            xs={12}
            container
            justifyContent="center"
            sx={{
              gap: '1rem',
              marginTop: '3rem',
            }}
          >
            <PrimaryBtn label={t('index.primaryButtonDownload')} to={downloadFile} />
            <PrimaryBtn isPrimary label={t('index.primaryButtonGo')} to="/plan/my-warning-signs" />
          </Grid>
        </Grid>
      </Layout>
      <Footer />
    </>
  );
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
